<template>
    <div class="review-search-content" v-if="isShow" @touchmove="preventEvent($event)">
        <div class="review-search-bg bg-cover"></div>
        <div class="review-search-nav bg-blue">
            <div class="review-search-cancel div--inlineBlock" @click="closeFilter">取消</div>
            <div class="review-search-clear div--inlineBlock" @click="clearFilter">清空筛选</div>
            <div class="review-search-confirm div--inlineBlock" @click="confirmFilter">确认</div>
        </div>
        <div class="review-search-select bg-white">
            <div class="review-search-destination" v-if="showType === 0">
                <div class="review-search-item-title">目的地</div>
                <div class="review-search-items">
                    <div class="review-search-item div--inlineBlock" v-bind:class="{active: temporaryCountry === ''}" @click="selectCountry('')"><span>不限</span></div>
                    <div class="review-search-item div--inlineBlock" v-for="(item, index) in countries" :key="index" v-bind:class="{active: temporaryCountry === item}" @click="selectCountry(item)"><span>{{item}}</span></div>
                </div>
            </div>
            <div class="review-search-ship" v-if="showType === 0">
                <div class="review-search-item-title">游轮</div>
                <div class="review-search-items">
                    <div class="review-search-item div--inlineBlock" v-bind:class="{active: temporaryShip === ''}" @click="selectShip('')"><span>不限</span></div>
                    <div class="review-search-item div--inlineBlock" v-for="(item, index) in ships" :key="index" v-bind:class="{active: temporaryShip === item}" @click="selectShip(item)"><span>{{item}}</span></div>
                </div>
            </div>
            <div class="review-search-filter-content" v-if="showType === 1">
                <div @click="selectOrder(0)">
                    <span>出行时间</span>
                    <img class="imgActive" v-bind:class="{arrowUpB: temporaryOrder === 1}" v-if="temporaryOrder === 0 || temporaryOrder === 1" src="../../assets/blue_arrow.png" alt="">
                    <img v-else src="../../assets/gray_arrow.png" alt="">
                </div>
                <div @click="selectOrder(1)">
                    <span>发布时间</span>
                    <img class="imgActive" v-bind:class="{arrowUpB: temporaryOrder === 6}" v-if="temporaryOrder === 5 || temporaryOrder === 6" src="../../assets/blue_arrow.png" alt="">
                    <img v-else src="../../assets/gray_arrow.png" alt="">
                </div>
                <div @click="selectOrder(2)">
                    <span>点赞数</span>
                    <img class="imgActive" v-bind:class="{arrowUpB: temporaryOrder === 11}" v-if="temporaryOrder === 10 || temporaryOrder === 11" src="../../assets/blue_arrow.png" alt="">
                    <img v-else src="../../assets/gray_arrow.png" alt="">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'TravelNoteFilter',
        props: {
            isShow: {
                type: Boolean,
                default: false
            },
            showType: {
                type: Number,
                default: 0
            },
            countries: {
                type: Array,
                default: function () {}
            },
            ships: {
                type: Array,
                default: function () {}
            },
            country: {
                type: String,
                default: ''
            },
            ship: {
                type: String,
                default: ''
            },
            order: {
                type: Number,
                default: 0
            }
        },
        data () {
            return {
                temporaryCountry: '',
                temporaryShip: '',
                temporaryOrder: 0
            }
        },
        methods: {
            preventEvent (e) {
                e.preventDefault()
            },
            closeFilter () {
                this.$emit('on-close')
            },
            clearFilter () {
                if (this.showType === 0) {
                    this.temporaryCountry = ''
                    this.temporaryShip = ''
                }
                if (this.showType === 1) {
                    this.temporaryOrder = 0
                }
                this.$emit('on-clear')
            },
            confirmFilter () {
                this.$emit('on-confirm', {
                    country: this.temporaryCountry,
                    ship: this.temporaryShip,
                    orderBy: this.temporaryOrder
                })
            },
            selectCountry (item) {
                this.temporaryCountry = item
            },
            selectShip (item) {
                this.temporaryShip = item
            },
            selectOrder (type) {
                switch (type) {
                    case 0:
                        this.temporaryOrder = this.temporaryOrder === 0 ? 1 : 0
                        break
                    case 1:
                        this.temporaryOrder = this.temporaryOrder === 5 ? 6 : 5
                        break
                    case 2:
                        this.temporaryOrder = this.temporaryOrder === 10 ? 11 : 10
                        break
                }
            }
        }
    }
</script>

<style lang="less" scoped>
    .review-search-content {
        position: absolute;
        width: 100%;
        top: 50px;
        z-index: 2;
        height: 100%;
    }

    .review-search-bg {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
    }

    .review-search-filter-content > div {
        border-top: 1px solid #eee;
        height: 35px;
        line-height: 35px;
        text-align: center;
        color: #666;
        position: relative;
        font-size: 13px;
    }
    .review-search-filter-content > div>span {
        display:inline-block;
        width:107px;
    }
    .review-search-filter-content > div > img.arrowUpB {
        transform: rotate(180deg);
        -ms-transform: rotate(180deg); /* Internet Explorer */
        -moz-transform: rotate(180deg); /* Firefox */
        -webkit-transform: rotate(180deg); /* Safari 和 Chrome */
        -o-transform: rotate(180deg); /* Opera */
    }

    .review-search-filter-content > div.active {
        color: #061556;
    }

    .review-search-filter-content > div i {
        color: #f0af11;
        font-size: 18px;
        visibility: hidden;
        position: absolute;
        right: 29px;
        top: 6px;
    }

    .review-search-filter-content > div.active i {
        visibility: visible;
    }


    .review-search-content .review-search-select {
        position: relative;
    }

    .review-search-content .review-search-nav {
        color: white;
        font-size: 13px;
        height: 36px;
        line-height: 36px;
        padding: 0px 20px;
        position: relative;
    }

    .review-search-content .review-search-confirm {
        position: absolute;
        top: 1px;
        right: 20px;
    }

    .review-search-content .review-search-cancel {
        position: absolute;
        top: 1px;
        left: 20px;
    }

    .review-search-content .review-search-clear {
        border-radius: 5px;
        height: 28px;
        line-height: 28px;
        padding: 0px 5px;
        border: 1px solid white;
        position: absolute;
        top: 4px;
        left: 155px;
    }

    .review-search-content .review-search-destination {
        border-bottom: 1px dotted #ccc;
    }

    .review-search-content .review-search-item-title {
        color: #061556;
        font-size: 14px;
        padding: 10px;
        font-weight: bold;
    }

    .review-search-content .review-search-items {
        margin: 5px 0px;
        font-size: 13px;
    }

    .review-search-content .review-search-items .active span {
        background-color: #061556;
        color: white;
        border-radius: 8px;
    }

    .review-search-content .review-search-item {
        width: 19%;
        text-align: center;
        margin-bottom: 6px;
    }
    .review-search-ship .review-search-item:first-child {
        width: 19%;
    }
    .review-search-ship .review-search-item {
        width:25%;
    }

    .review-search-content .review-search-item span {
        display: inline-block;
        padding: 5px 6px;
    }
</style>
